import React, { useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import SettingsModal from '../../../clientSettings/SettingsModal';
import Toggle from '../../../Toggle';
import { toast } from '../../../Toast';
import { SelectBox } from '../../shared';
import { FileBox, FileDrop } from './FileBox';
import { GovSection, PickedFile, nameFromFile, sizeText } from './governanceData';

export interface Upload { picked: PickedFile; name: string; section: string; visible: boolean }

interface Props {
    sections: GovSection[];
    onClose: () => void;
    onUpload: (u: Upload) => void;
}

const MAX_KB = 25 * 1024;

// Corporate governance › Upload a governance document (spec 409:11980)
const UploadDocumentModal: React.FC<Props> = ({ sections, onClose, onUpload }) => {
    const [picked, setPicked] = useState<PickedFile | null>(null);
    const [name, setName] = useState('');
    const [section, setSection] = useState(sections[0]?.id ?? '');
    const [visible, setVisible] = useState(true);

    const pick = (f: PickedFile) => {
        if (f.sizeKb > MAX_KB) {
            toast.error(`${f.file} is ${sizeText(f.sizeKb)} — the limit is 25 MB`);
            return;
        }
        setPicked(f);
        // name it from the file unless one was typed already
        if (!name.trim()) setName(nameFromFile(f.file));
    };
    const byName = (n: string) => sections.find(s => s.name === n)?.id ?? section;
    const current = sections.find(s => s.id === section);

    return <SettingsModal icon={<FiUpload />} title="Upload a Governance Document" sub="PDF, Word or Excel · up to 25 MB" onClose={onClose}
        footer={<button type="button" className="btn-primary" disabled={!picked || !name.trim()}
            onClick={() => picked && onUpload({ picked, name: name.trim(), section, visible })}>{visible ? 'Upload & Publish' : 'Upload'}</button>}>
        {picked
            ? <FileBox file={picked.file} sub={`${picked.kind} · ${sizeText(picked.sizeKb)} · uploaded`} removeLabel="Remove the file" onRemove={() => setPicked(null)} />
            : <FileDrop onPick={pick} />}
        <label className="field">
            <span className="label">Name shown on the website</span>
            <input value={name} placeholder="Securities Trading Policy" onChange={e => setName(e.target.value)} />
        </label>
        <div className="field">
            <span className="label">Section</span>
            <SelectBox className="hub-select-full" label="Section" value={current?.name ?? ''} options={sections.map(s => s.name)} onChange={v => setSection(byName(v))} />
        </div>
        <div className="setting-row hub-modal-toggle">
            <div className="text"><span className="title">Show on the website straight away</span><span className="hint">Turn off to upload now and show it later</span></div>
            <Toggle checked={visible} onChange={setVisible} label="Show on the website straight away" />
        </div>
    </SettingsModal>;
};

export default UploadDocumentModal;
